import React from 'react';

const Footer = () => {
  return (
    <footer style={footerStyle}>
      &copy; {new Date().getFullYear()} PBIS Portal. All rights reserved. |{' '}
      <a href="/contact" style={linkStyle}>Contact Support</a>
    </footer>
  );
};

const footerStyle = {
  textAlign: 'center',
  padding: '1rem',
  fontSize: '0.9rem',
  color: '#888',
  borderTop: '1px solid #ddd',
  backgroundColor: '#f9fafb',
  marginTop: 'auto'
};

const linkStyle = {
  color: '#3b82f6',
  textDecoration: 'none',
  fontWeight: '500'
};

export default Footer;